import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import moment from "moment";
import { updateField } from "@joandvgv/vuex-map-fields";
import Vue from "vue";
import { ACCOUNT_STATUS } from "@Shared/js/constants";
import { isEmpty } from "lodash";
import { REPORT_DEFAULT_PREFERENCES_STRUCTURE } from "@Broker/@Modules/clients/reports/store/reports-default-state";
export const SET_SESSION_DETAILS = "SET_SESSION_DETAILS";
export const SET_NOTIFICATION_PREFERENCES = "SET_NOTIFICATION_PREFERENCES";
export const SET_PERSONAL_DETAILS = "SET_PERSONAL_DETAILS";
export const SET_CLIENT_BOARD_VIEW = "SET_CLIENT_BOARD_VIEW";
export const SET_ACCOUNT_PREFERENCES = "SET_ACCOUNT_PREFERENCES";
export const SET_ACCOUNT_DETAILS = "SET_ACCOUNT_DETAILS";
export const SET_EMAIL_SIGNATURE = "SET_EMAIL_SIGNATURE";
export const SET_BROKERAGE_SUBDOMAIN = "SET_BROKERAGE_SUBDOMAIN";
export const SET_PROFILE_PICTURE = "SET_PROFILE_PICTURE";
export const SET_EMAIL_VERIFICATION = "SET_EMAIL_VERIFICATION";
export const SET_ACCOUNT_SUBDOMAIN = "SET_ACCOUNT_SUBDOMAIN";
export const SET_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY = "SET_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY";
export const SET_STYLES = "SET_STYLES";
export const SET_LAST_CACHE_CHECK = "SET_LAST_CACHE_CHECK";
export const SET_BOARDS_CLASSIC_FILTERS = "SET_BOARDS_CLASSIC_FILTERS";
export const SET_TIED_BROKERAGE = "SET_TIED_BROKERAGE";
const mutations = {
  [SET_SESSION_DETAILS]: (state, session) => {
    for (const key in session) {
      state[key] = session[key];
    }
    if (isEmpty(state.accountPreferences.reportDefaultSettings)) {
      Vue.set(state.accountPreferences, "reportDefaultSettings", REPORT_DEFAULT_PREFERENCES_STRUCTURE);
    }
    const expirationTime = state["expires_in"];
    const now = moment();
    now.add(expirationTime, "second");
    state.expiration = now.toString();
  },
  [SET_PERSONAL_DETAILS]: (state, {
    userDetails
  }) => {
    state.userDetails = _objectSpread(_objectSpread({}, state.userDetails), userDetails);
  },
  [SET_TIED_BROKERAGE]: (state, {
    tiedBrokerage
  }) => {
    Vue.set(state.brokerageDetails.tiedBrokerages, 0, tiedBrokerage);
  },
  [SET_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY]: (state, {
    viewOnly
  }) => {
    if (state.accountDetails.accessRights) {
      Vue.set(state.accountDetails.accessRights, "viewOnly", viewOnly);
    }
  },
  [SET_ACCOUNT_DETAILS]: (state, {
    accountDetails
  }) => {
    state.accountDetails = _objectSpread(_objectSpread({}, state.accountDetails), accountDetails);
  },
  [SET_NOTIFICATION_PREFERENCES]: (state, {
    preferences
  }) => {
    state.notificationPreferences = preferences;
  },
  [SET_CLIENT_BOARD_VIEW]: (state, {
    clientBoardView
  }) => {
    state.clientBoardView = clientBoardView;
  },
  [SET_ACCOUNT_PREFERENCES]: (state, {
    accountPreferencesDetails
  }) => {
    state.accountPreferences = _objectSpread(_objectSpread(_objectSpread({}, state.accountPreferences), accountPreferencesDetails), {}, {
      reportDefaultSettings: _objectSpread(_objectSpread({}, state.accountPreferences.reportDefaultSettings), accountPreferencesDetails.reportDefaultSettings)
    });
    if (isEmpty(state.accountPreferences.reportDefaultSettings)) {
      Vue.set(state.accountPreferences, "reportDefaultSettings", REPORT_DEFAULT_PREFERENCES_STRUCTURE);
    }
  },
  [SET_EMAIL_SIGNATURE]: (state, emailSignature) => {
    state.accountPreferences.emailSignature = emailSignature;
  },
  [SET_BROKERAGE_SUBDOMAIN]: (state, subdomain) => {
    state.brokerageDetails.tiedBrokerages[0].subdomain = subdomain;
  },
  [SET_EMAIL_VERIFICATION]: (state, {
    pendingEmailVerification,
    email
  }) => {
    state.userDetails.email = email;
    if (pendingEmailVerification) {
      state.accountDetails.accountStatus = ACCOUNT_STATUS.pendingEmailVerification;
    }
  },
  [SET_STYLES]: (state, {
    styles
  }) => {
    state.styles = _objectSpread(_objectSpread({}, state.styles), styles);
  },
  [SET_LAST_CACHE_CHECK]: (state, lastCacheCheck) => {
    state.lastCacheCheck = lastCacheCheck;
  },
  [SET_BOARDS_CLASSIC_FILTERS]: (state, {
    boardId,
    value
  }) => {
    Vue.set(state.boardClassicFilters, boardId, value);
  },
  updateField
};
export default mutations;